import {combineReducers} from "@reduxjs/toolkit";
import highlight from "features/pages/people/highlights/reducer";
import favorites from "features/pages/people/favorite/reducer";
import search from "features/pages/people/search/reducer";
import favorite from "./favorite/reducer";

export default combineReducers({
    highlight,
    favorites,
    favorite,
    search
})